(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const closeButton = document.querySelector('[data-mobile-nav-close]');

  function openMobileNav() {
    mobileNav.classList.add('is-open');
    menuToggle.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    mobileNav.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  menuToggle.addEventListener('click', openMobileNav);
  closeButton.addEventListener('click', closeMobileNav);

  mobileNav.addEventListener('click', (e) => {
    if (e.target === mobileNav) {
      closeMobileNav();
    }
  });

  document.querySelectorAll('[data-mobile-nav] .header__mobile-nav-link').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var thumbnails = document.querySelectorAll('[data-thumbnail]');
    var mainImage = document.querySelector('[data-product-main-image] img');
    if (!mainImage || !thumbnails.length) return;

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImage.src = thumb.dataset.imageUrl;
        mainImage.alt = thumb.dataset.imageAlt;
      });
    });
  })();

  (function() {
    var pickers = document.querySelectorAll('[data-date-picker]');
    if (!pickers.length) return;

    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

    pickers.forEach(function(picker) {
      var input = picker.querySelector('[data-date-input]');
      var dropdown = picker.querySelector('[data-date-dropdown]');
      var daysContainer = picker.querySelector('[data-date-days]');
      var monthLabel = picker.querySelector('[data-date-month-label]');
      var prevBtn = picker.querySelector('[data-date-prev]');
      var nextBtn = picker.querySelector('[data-date-next]');

      var today = new Date();
      var currentMonth = today.getMonth();
      var currentYear = today.getFullYear();
      var selectedDate = null;

      function render() {
        monthLabel.textContent = MONTHS[currentMonth] + ' ' + currentYear;
        daysContainer.innerHTML = '';

        var firstDay = new Date(currentYear, currentMonth, 1).getDay();
        var adjustedFirst = (firstDay === 0) ? 6 : firstDay - 1;
        var daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        var daysInPrev = new Date(currentYear, currentMonth, 0).getDate();

        for (var i = adjustedFirst - 1; i >= 0; i--) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'date-picker__day date-picker__day--other';
          btn.textContent = daysInPrev - i;
          btn.disabled = true;
          daysContainer.appendChild(btn);
        }

        for (var d = 1; d <= daysInMonth; d++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'date-picker__day';
          btn.textContent = d;

          var isToday = (d === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear());
          if (isToday) btn.classList.add('date-picker__day--today');

          if (selectedDate && d === selectedDate.getDate() && currentMonth === selectedDate.getMonth() && currentYear === selectedDate.getFullYear()) {
            btn.classList.add('date-picker__day--selected');
          }

          (function(day) {
            btn.addEventListener('click', function() {
              selectedDate = new Date(currentYear, currentMonth, day);
              var formatted = day + ' ' + MONTHS[currentMonth] + ' ' + currentYear;
              input.value = formatted;
              dropdown.classList.remove('is-open');
              render();
            });
          })(d);

          daysContainer.appendChild(btn);
        }

        var totalCells = adjustedFirst + daysInMonth;
        var remaining = (7 - (totalCells % 7)) % 7;
        for (var r = 1; r <= remaining; r++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'date-picker__day date-picker__day--other';
          btn.textContent = r;
          btn.disabled = true;
          daysContainer.appendChild(btn);
        }
      }

      input.addEventListener('click', function(e) {
        e.stopPropagation();
        dropdown.classList.toggle('is-open');
        if (dropdown.classList.contains('is-open')) render();
      });

      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        currentMonth--;
        if (currentMonth < 0) { currentMonth = 11; currentYear--; }
        render();
      });

      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        currentMonth++;
        if (currentMonth > 11) { currentMonth = 0; currentYear++; }
        render();
      });

      document.addEventListener('click', function(e) {
        if (!picker.contains(e.target)) {
          dropdown.classList.remove('is-open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  const carousel = document.querySelector('[data-testimonials-carousel]');
  if (carousel) {
    const track = carousel.querySelector('[data-testimonials-track]');
    const slides = track.querySelectorAll('[data-slide]');
    const dots = carousel.querySelectorAll('[data-testimonial-dot]');
    const prevBtn = carousel.querySelector('[data-testimonial-prev]');
    const nextBtn = carousel.querySelector('[data-testimonial-next]');

    let current = 0;
    let autoplayTimer = null;
    const autoplayDelay = 7000;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(() => goTo(current + 1), autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); startAutoplay(); });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.testimonialDot));
        startAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Touch swipe
    let touchStartX = 0;
    let touchEndX = 0;

    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) goTo(current + 1);
        else goTo(current - 1);
      }
      startAutoplay();
    }, { passive: true });

    startAutoplay();
  }

  } catch(e) { console.error(e); }
})();
})();
